import {BrowserModule} from '@angular/platform-browser';
import {Injector, NgModule} from '@angular/core';
import {CommonModule, DatePipe, HashLocationStrategy, LocationStrategy} from '@angular/common';
import {AppComponent} from './app.component';
import {NavigationComponent} from './components/navigation/navigation.component';
import {ConciliacionOptionComponent} from './components/navigation/options/conciliacion/conciliacion-option.component';
import {WebNavigationService} from "./components/navigation/navigation.service";
import {ConciliacionSubmenuComponent} from './components/navigation/options/conciliacion/conciliacion-submenu/conciliacion-submenu.component';
import {AppRoutingModule} from './app.routing';
import {PaymentsComponent} from './components/payments/phisical-account/payments.component';
import {PageNotFoundComponent} from './components/page-not-found/page-not-found.component';
import {MainContainerComponent} from './components/main-container/main-container.component';
import {PaginationService} from './core/pagination/paginator.service';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LoginComponent} from './components/login/login.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PaymentService} from './core/payments/payments.service';
import {TransferService} from "./core/transfers/transfers.service";
import {SalesService} from "./core/sales/sales.service";
import {UsersService} from "./core/customers/glotto-users.service";
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {
  CalendarModule,
  ChartModule,
  DataTableModule,
  DialogModule,
  DropdownModule,
  GrowlModule,
  MultiSelectModule,
  PaginatorModule,
  SharedModule,
  SliderModule,
  TabViewModule
} from 'primeng/primeng';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {environment} from "../environments/environment";
import {Environment} from './core/environment-core';
import {ModalModule} from 'ngx-bootstrap/modal';
import {LaddaModule} from 'angular2-ladda';

import {JwtTokenInterceptor} from "./core/auth/jwt-token.interceptor";
import {UrlsResources} from "./core/urls-resources";
import {AuthGuard} from "./components/common/auth-guard";
import {LocalStorageService} from "./core/storage/storage.service";
import {WebAuthService} from "./components/common/web-auth.service";
import {AuthService} from "./core/auth/auth.service";
import {PerfilComponent} from './components/perfil/perfil.component';
import {CommonHttpInterceptor} from "./core/common-http.interceptor";
import {MessageService} from "primeng/components/common/messageservice";
import {AccessGuard} from "./components/common/access-guard";
import {PortalGuard} from "./components/common/portal-guard";
import {ConciliacionTableComponent} from './components/conciliacion/conciliacion-table.component';
import {ConciliacionComponent} from './components/conciliacion/conciliacion.component';
import {ConciliacionChartComponent} from './components/conciliacion/conciliacion-chart.component';
import {ConciliacionService} from "./core/conciliacion/conciliacion.service";
import {BusinessRulesComponent} from "./components/businessRules/businessRules.component";
import {GameInfoTimeLimitComponent} from "./components/businessRules/gameInfo-time-limit/gameInfo-time-limit.component";
import {DrawDefTimeLimitComponent} from "./components/businessRules/drawdef-time-limit/drawDef-time-limit.component";
import {DrawGroupTimeLimitComponent} from "./components/businessRules/drawGroup-time-limit/drawGroup-time-limit.component";
import {BusinessRulesService} from "./core/business-rules/business-rules.service";
import {ProgolTimeLimitComponent} from "./components/businessRules/progol-time-limit/progol-time-limit.component";
import {PagerService} from "./core/pagination/pager.service";
import {DashboardComponent} from "./components/dashboard/dashboard.component";
import {LoginService} from "./components/login/login.service";
import {LoginServiceImpl} from "./components/login/login.service.impl";
import {RegistroUsuariosComponent} from './components/usuariosppap/registro-usuarios.component';
import {ConciliacionChartItemComponent} from './components/conciliacion/conciliacion-chart-item.component';
import {ValidationMessagesComponent} from "./core/validators/validation-messages.component";
import {RegistroUsuariosService} from "./components/usuariosppap/registro-usuarios.service";
import {PaymentsChartComponent} from "./components/payments/payments-chart.component";
import {BeginDate, EndDate, FormatDate} from "./core/pipes/format-date.pipe";
import {PaymentOptionComponent} from './components/navigation/options/payments/payment-option.component';
import {PaymentSubmenuComponent} from './components/navigation/options/payments/payments-submenu/payment-submenu.component';
import {EAccountComponent} from './components/payments/electronic-account/e-account.component';
import {TransferOptionComponent} from './components/navigation/options/transfers/transfer-option.component';
import {TransferSubmenuComponent} from './components/navigation/options/transfers/submenu/transfer-submenu.component';
import {WalletAccountComponent} from './components/transfers/wallet-account/wallet-account.component';
import {OpenPayService} from './core/openpay/openpay.service';
import {HandleError} from './core/handle-error';
import {ReadDtComponent} from './components/payments/read-dataTable/read-dt.component';
import {SalesChartComponent} from './components/sales/sales-chart.component';
import {GlottoUsersChartComponent} from './components/glotto-users/glotto-users-chart.component';
import {PromocionesComponent} from "./components/promociones/quantum/promociones.component";
import {PromocionesService} from "./core/promociones/promociones.service";
import {ActivationModalComponent} from "./components/promociones/quantum/activation-modal-component";
import {PrincipalModalComponent} from "./components/promociones/quantum/principal-modal-component";
import {InfoModalComponent} from "./components/promociones/info-modal.component";
import {SetPrincipalModalComponent} from "./components/promociones/set-principal-modal-component";
import {AdminPromotionComponent} from "./components/promociones/quantum/admin-promotion/admin-promotion.component";
import {DetailPromotionComponent} from "./components/promociones/quantum/detail-promotion/detail-promotion.component";
import {DetailTableComponent} from "./components/promociones/quantum/detail-promotion/detail-table.component";
/* referidos */
import {ReferralsService} from "./core/referrals/referrals.service";
import {ReferComponent} from "./components/referrals/admin-refer/refer.component";
import {ReferListComponent} from "./components/referrals/refer-list.component";
import {ActivationReferModalComponent} from "./components/referrals/activation-refer-modal-component";
import {PromotionsSubmenuComponent} from './components/navigation/options/promotions/promotions-submenu/promotions-submenu.component';
import {PromotionsOptionComponent} from "./components/navigation/options/promotions/promotions-option.component";
import {AddCodesModalComponent} from "./components/promociones/ganalottodo/add-codes-modal-component";
/* Promociones ganalottodo */
import {GanalottodoPromotionsComponent} from "./components/promociones/ganalottodo/ganalottodo-promotions.component";
import {GanalottodoPromotionComponent} from "app/components/promociones/ganalottodo/admin-promotion/ganalottodo-promotion.component";
import {BannersComponent} from './components/banners/banners.component';
import {AdminBannersComponent} from './components/banners/admin-banners/admin-banners.component';
import {BannerService} from "./core/banner/banner.service";
import {ActivationMessageModalComponent} from "./components/banners/modal/activation-message-modal-component";
import {AdvanceUsersComponent} from './components/advance-users/advance-users.component';
import {RisksModuleComponent} from "./components/risks-module/risks-module.component";
import {ModuleRiskService} from "./core/risk-module/module-risk.service";
import {UsuariosOptionComponent} from "./components/navigation/options/usuarios/usuarios-option.component";
import {UsuariosSubmenuComponent} from "./components/navigation/options/usuarios/usuarios-submenu/usuarios-submenu.component";
import {GanalottodoUsersComponent} from "./components/usuarios-ganalottodo/ganalottodo-users.component";
import {GanalottodoUserComponent} from "app/components/usuarios-ganalottodo/ganalottodo-user/ganalottodo-user.component";
import {MegamillionsRulesComponent} from "./components/businessRules/megamillions-rules/megamillions-rules.component";
import {EAccountService} from "./components/payments/electronic-account/e-account.service";
import { UploadAwardsComponent } from './components/upload-awards/upload-awards.component';
import {ConfirmFileModalComponent} from "./components/upload-awards/modal/confirm-file-modal-component";
import {UploadAwardsService} from "./core/upload-awards/upload-awards.service";


@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    ConciliacionOptionComponent,
    ConciliacionSubmenuComponent,
    PaymentsComponent,
    PageNotFoundComponent,
    MainContainerComponent,
    LoginComponent,
    PerfilComponent,
    BusinessRulesComponent,
    GameInfoTimeLimitComponent,
    DrawGroupTimeLimitComponent,
    DrawDefTimeLimitComponent,
    ProgolTimeLimitComponent,
    ConciliacionTableComponent,
    ConciliacionComponent,
    ConciliacionChartComponent,
    DashboardComponent,
    RegistroUsuariosComponent,
    ConciliacionChartItemComponent,
    ValidationMessagesComponent,
    PaymentsChartComponent,
    FormatDate,
    BeginDate,
    EndDate,
    PaymentOptionComponent,
    PaymentSubmenuComponent,
    EAccountComponent,
    TransferOptionComponent,
    TransferSubmenuComponent,
    WalletAccountComponent,
    ReadDtComponent,
    SalesChartComponent,
    GlottoUsersChartComponent,
    PromocionesComponent,
    AdminPromotionComponent,
    ActivationModalComponent,
    PrincipalModalComponent,
    InfoModalComponent,
    DetailPromotionComponent,
    DetailTableComponent,
    SetPrincipalModalComponent,
    ReferComponent,
    ReferListComponent,
    ActivationReferModalComponent,
    GanalottodoPromotionsComponent,
    PromotionsOptionComponent,
    PromotionsSubmenuComponent,
    AddCodesModalComponent,
    GanalottodoPromotionComponent,
    BannersComponent,
    AdminBannersComponent,
    ActivationMessageModalComponent,
    AdvanceUsersComponent,
    RisksModuleComponent,
    UsuariosOptionComponent,
    UsuariosSubmenuComponent,
    GanalottodoUsersComponent,
    GanalottodoUserComponent,
    MegamillionsRulesComponent,
    UploadAwardsComponent,
    ConfirmFileModalComponent
  ],
  entryComponents: [
    ActivationModalComponent,
    PrincipalModalComponent,
    InfoModalComponent,
    SetPrincipalModalComponent,
    ActivationReferModalComponent,
    AddCodesModalComponent,
    ActivationMessageModalComponent,
    ConfirmFileModalComponent
  ],
  exports: [
    ModalModule,
    DataTableModule
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    DataTableModule,
    SharedModule,
    CalendarModule,
    DropdownModule,
    MultiSelectModule,
    NgbModule.forRoot(),
    SliderModule,
    PaginatorModule,
    HttpClientModule,
    GrowlModule,
    ReactiveFormsModule,
    TabViewModule,
    DialogModule,
    ChartModule,
    ModalModule.forRoot(),
    LaddaModule.forRoot({})
  ],
  providers: [
    WebNavigationService,
    PaginationService,
    AuthGuard,
    AccessGuard,
    PortalGuard,
    LocalStorageService,
    UrlsResources,
    EAccountService,
    PaymentService,
    TransferService,
    PagerService,
    RegistroUsuariosService,
    SalesService,
    UsersService,
    PromocionesService,
    BannerService,
    ModuleRiskService,
    DatePipe,
    UploadAwardsService,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    {
      provide: LoginService,
      useClass: LoginServiceImpl
    },
    MessageService,
    ConciliacionService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtTokenInterceptor,
      deps: [Injector],
      multi: true,
    }, {
      provide: HTTP_INTERCEPTORS,
      useClass: CommonHttpInterceptor,
      deps: [MessageService],
      multi: true,
    },
    WebAuthService,
    {
      provide: AuthService,
      useExisting: WebAuthService
    },
    {
      provide: Environment,
      useValue: environment
    },
    BusinessRulesService,
    OpenPayService,
    HandleError,
    ReferralsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/app.module.ts